import type { RuleTargetKind } from './rule-targets.js';

export const METRIC_UNITS = ['percent', 'count', 'number', 'state'] as const;

export type MetricUnit = (typeof METRIC_UNITS)[number];

export type MetricSource = 'node' | 'app';

export interface MetricDefinition {
  key: string;
  label: string;
  unit: MetricUnit;
  source: MetricSource;
}

export const NODE_UP_METRIC: MetricDefinition = {
  key: 'node_up',
  label: 'Server reachable',
  unit: 'state',
  source: 'node',
};

export const APP_UP_METRIC: MetricDefinition = {
  key: 'app_up',
  label: 'Application reachable',
  unit: 'state',
  source: 'app',
};

/** Metrics derived from node_exporter; available for every client with `nodeExporter` configured. */
export const NODE_METRICS: readonly MetricDefinition[] = [
  NODE_UP_METRIC,
  { key: 'cpu_percent', label: 'CPU usage', unit: 'percent', source: 'node' },
  { key: 'cpu_core_percent', label: 'Busiest CPU core', unit: 'percent', source: 'node' },
  { key: 'memory_percent', label: 'Memory usage', unit: 'percent', source: 'node' },
  { key: 'disk_percent', label: 'Disk usage', unit: 'percent', source: 'node' },
  { key: 'load1', label: 'Load average (1m)', unit: 'number', source: 'node' },
];

export function toMetricDefinition(
  metric: { key: string; label: string; unit: MetricUnit },
  kind: RuleTargetKind,
): MetricDefinition {
  if (metric.key === NODE_UP_METRIC.key) return NODE_UP_METRIC;
  if (metric.key === APP_UP_METRIC.key) return APP_UP_METRIC;
  return { key: metric.key, label: metric.label, unit: metric.unit, source: kind === 'SERVER' ? 'node' : 'app' };
}
